<div class="container-fluid">
    <div id="header" class="row">
        <div class="col-12 p-0 d-flex justify-content-between align-items-center">
            <div routerLink="/pages/dashboard" id="header-leftside" class="d-flex align-items-center">
                <div id="header-logo">
                </div>
                <div id="header-title" pTooltip="{{versionTooltip}}" tooltipZIndex="9999999" appendTo="body"
                    tooltipPosition="bottom" [escape]="false" showDelay="1000" hideDelay="1750">
                    {{title}}
                </div>
            </div>
            <div id="header-centralside">
                <div class="d-flex" *ngIf="!isTablet">
                    <a *ngFor="let item of items" class="py-3" routerLink="{{'/pages/'+ item.link}}"
                        >{{ item.label | translate}}
                    </a>
                </div>
                <div class="position-relative position-button" *ngIf="isTablet">
                    <mapfre-auditlib-button type="inverted" popup="true" class="padding-right-40"
                        (click)="showSubheader = !showSubheader">
                        {{ 'MENU.LABEL' | translate }}
                    </mapfre-auditlib-button>
                    <mapfre-auditlib-popup class="margin-header" [(display)]="showSubheader">
                        <div class="content">
                            <ul class="menu-list">
                                <li *ngFor="let item of items" class="cursor-pointer"
                                    (click)="goRoute('/pages/'+item.link)">
                                    {{ item.label | translate}}
                                </li>
                            </ul>
                        </div>
                    </mapfre-auditlib-popup>
                </div>
            </div>
            <div id="header-rightside" class="d-flex align-items-center">
                <svg preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" width="40" height="40" viewBox="0 0 500 500">
                    <circle cx="255" cy="255" r="230" />
                    <text x="255" y="246" dy="0.4em" text-anchor="middle" fill="var(--greyish-brown)" style="dominant-baseline:auto; font-family: var(--primaryFont);"
                        font-size="180" font-weight="700">
                        {{ userFirstLetters }}</text>
                </svg> 
                <div class="ms-2 currentLang color-white cursor-pointer margins-language"
                    (click)="displayLanguageModal = true">{{currentLang}}</div>
                <i title="{{'HEADER.EXIT' | translate}}"
                pTooltip="{{versionTooltip}}" tooltipZIndex="9999999" appendTo="body" tooltipPosition="bottom"
                [escape]="false" showDelay="1000" hideDelay="1750"
                class="ms-2 pi pi-power-off font-large cursor-pointer" (click)="displayModal=true"></i>
            </div>
        </div>
    </div>
</div>

<mapfre-auditlib-modal [(visible)]="displayModal">
    <div class="modal-content">
        <h3 translate class="mt-0">HEADER.LOGOUT</h3>
        <div class="padding-question" translate>FLOW.QUESTION</div>
        <mapfre-auditlib-button (click)="onLogoutClick()">
            <span translate class="white">HEADER.EXIT</span>
        </mapfre-auditlib-button>
    </div>
</mapfre-auditlib-modal>

<mapfre-auditlib-modal [(visible)]="displayLanguageModal">
        <div class="modal-lenguages">
            <div class="my-4 col-12" *ngFor="let lang of availableLangs">
                <mapfre-auditlib-button (click)="changeLanguage(lang?.code)">
                    <span translate class="white color-white px-5 text-uppercase">{{lang?.code}}</span>
                </mapfre-auditlib-button>
            </div>
        </div>
</mapfre-auditlib-modal>
